'use client'

import dynamic from 'next/dynamic'

import type { JobPageItem, TermsConditions } from '@types'

import Button from '@components/buttons/button'
import ApplyDisclaimer from '@components/job/apply-disclaimer'

import styles from './apply-banner.module.scss'

import { useCallback } from 'react'
import useApplyWithSonicApply from '../hooks/useApplyWithSonicApply'

const ScrollApplyButton = dynamic(() => import('./scroll-apply-button'), { ssr: false })

type BannerType = {
  dataCy?: string
  isEligibleToApply: boolean
  isLinkedin?: boolean
  jobSource: JobPageItem['source']
  legals: TermsConditions[]
  scrollButton?: boolean
  totalInterestsShown?: number
  redirect: boolean
  externalJobUrl?: string | null
}

function ApplyBanner({
  scrollButton,
  dataCy,
  legals,
  isLinkedin,
  totalInterestsShown,
  jobSource,
  isEligibleToApply,
  redirect,
  externalJobUrl,
}: BannerType): JSX.Element {
  const applyWithSonicApply = useApplyWithSonicApply()

  const handleRedirect = useCallback(() => {
    if (redirect && externalJobUrl) {
      window.open(externalJobUrl, '_blank')
    }
  }, [redirect, externalJobUrl])

  return (
    <>
      <div className={styles.apply}>
        <p className="h2">
          {totalInterestsShown && totalInterestsShown > 25
            ? 'Don’t miss out on this top job!'
            : 'Apply now in a few quick clicks'}
        </p>
        <Button
          onClick={redirect ? handleRedirect : applyWithSonicApply}
          disabled={!isEligibleToApply}
          dataCy={dataCy}
          className={styles['apply-btn']}
          variant="yellow"
        >
          Apply now
        </Button>
        <ApplyDisclaimer
          termsConditions={legals}
          jobSource={jobSource}
          isLinkedin={isLinkedin}
          isEligibleToApply={isEligibleToApply}
        />
      </div>
      {scrollButton && isEligibleToApply && (
        <ScrollApplyButton
          applyClick={redirect ? handleRedirect : applyWithSonicApply}
          legals={legals}
          jobSource={jobSource}
          isEligibleToApply={isEligibleToApply}
        />
      )}
    </>
  )
}

export default ApplyBanner
